import { Button, type ButtonProps, theme } from 'antd'
import { useMemo } from 'react'
import { useSchedulePageFilters } from '../../Context/Filters/SchedulePageFilterContext'

export const ShiftBlock = ({
  shiftType,
  children,
  ...rest
}: { shiftType?: 'am' | 'pm' | 'error' | string | null } & Omit<
  ButtonProps,
  'value' | 'className' | 'style' | 'variant' | 'color'
>) => {
  const { useToken } = theme
  const { token } = useToken()
  const { datePickerType } = useSchedulePageFilters()
  const styles = useMemo(() => {
    switch (shiftType) {
      case 'error':
        return { border: token.colorErrorBorder, color: 'red' as const }
      case 'am':
        return { border: token.colorWarningBorder, color: 'yellow' as const }
      case 'pm':
        return { border: token.colorPrimaryBorder, color: 'blue' as const }
      default:
        return { border: token.colorBorder, color: token.colorHighlight as unknown as 'default' }
    }
  }, [token, shiftType])
  return (
    <Button
      {...rest}
      className={`shift-cell ${shiftType}`}
      style={{ borderColor: styles.border }}
      variant='filled'
      color={styles.color}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flex: 1,
          gap: '4px',
          width: '100%',
          alignItems: 'center',
          justifyContent: datePickerType === 'week' ? 'flex-start' : 'center',
        }}
      >
        {children}
      </div>
    </Button>
  )
}
